import { TopBanner } from '@repo/design-system-kit';
import { FormattedMessage } from 'react-intl';
import styles from './styles.module.css';

export function WelcomePromoBanner() {
  return (
    <TopBanner
      className={styles.welcomePromoBanner}
      data-test-welcome-promo-banner
      dismissable={false}
      /* eslint-disable-next-line @typescript-eslint/no-empty-function -- onClose is required*/
      onClose={() => {}}
      type="info"
    >
      <FormattedMessage id="welcome.promo-banner.beglaubigt" />
    </TopBanner>
  );
}

export const welcomePromoBannerElement = <WelcomePromoBanner />;
